import angular from 'angular';
import EditCategoryComponent from './edit.component';

const editCategoryModule = angular.module('tinaba.components.category.edit', [])

.component('editCategory', EditCategoryComponent);

export default editCategoryModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/categories/edit/edit.js
 **/